import { SettingsObject } from '@hooks/useSettings';

export const prCte: Partial<SettingsObject> = {};
